import React from "react";

const AIStatus = (props) => {
    const { aiStatus } = props;
    return (
        <div className={`ai-status ${aiStatus.status === 'completed' ? 'completed' : aiStatus.status === 'failed' ? 'failed' : 'processing'}`}>
            <div className="ai-status-row">
                {aiStatus.status !== 'completed' && aiStatus.status !== 'failed' && (
                    <div className="loader" />
                )}
                {aiStatus.status === 'completed' && <span className="status-icon success">✓</span>}
                {aiStatus.status === 'failed' && <span className="status-icon failed">✗</span>}
                <span className="status-message">{aiStatus.message}</span>
            </div>
            {aiStatus.total > 0 && aiStatus.status !== 'completed' && aiStatus.status !== 'failed' && (
                <div className="ai-progress-bar">
                    <div className="ai-progress-fill" style={{ width: `${Math.round((aiStatus.current / aiStatus.total) * 100)}%` }} />
                </div>
            )}
        </div>
    )
};

export default AIStatus;
